<template>
    <div v-show="this.items.length!==0">
        <warning>
                <div class="flex justify-between">
                    <div>Es liegt eine Meldung für mindestens einen Schreibtisch vor.</div>
                    <div class="ml-2">
                        <button-white><a href="/admin/pages/error_messages">Meldung anzeigen</a></button-white>
                    </div>
                </div>

        </warning>

    </div>
</template>

<script>
import Warning from "./UI/Warning";
import ButtonWhite from "./UI/ButtonWhite.vue"

export default {
    name: "ScheduleErrorsWarning",
    components: {Warning, ButtonWhite},

    data: () => ({
        items: [],
    }),

    mounted() {
        this.load();
    },

    methods: {
        load() {
            window.axios.get('/admin/schedules/error').then(response => {
                this.items = response.data.data;
            })
        },
    }
}
</script>

<style scoped>

</style>
